export default {
    computed: {

        eventData() {
            return this.$store.state.registration.eventData
        },

        registrationData() {
            return this.$store.state.registration.registrationData
        },

        newsletterData() {
            return this.$store.state.registration.newsletterData
        },

        formSelectChoices() {
            return this.$store.state.registration.formSelectChoices
        },

        occupancy() {
            return this.$store.state.registration.occupancy
        },

        onlineRegistrationFields() {
            return this.$store.state.registration.onlineRegistrationFields
        },

        eventIsLoaded() {
            return this.$store.state.registration.eventIsLoaded
        },

        registrationFinishedSuccessful() {
            return this.$store.state.registration.registrationFinishedSuccessful
        },

        participatingPersons() {
            return this.registrationData?.participatingPersons ?? []
        },

        chargeable() {
            return this.$store.getters['registration/chargeable']
        },

        tooManyAttemptsAt() {
            return this.$store.state.registration.tooManyAttemptsAt
        },

        retryAfter() {
            return this.$store.state.registration.retryAfter
        },

        changeWordingRegistrationBuy(){
            return this.eventData?.changeWordingRegistrationBuy
        },

        eventCacheData(){
            return this.eventData?.eventCacheData
        },

        previewMode: {
            get: function () {
                return this.$store.state.registration.previewMode
            },
            set: function (value) {
                this.$store.commit('registration/setPreviewMode', value)
            }
        },

        caregiverToken: {
            get: function () {
                return this.$store.state.registration.caregiverToken
            },
            set: function (value) {
                this.$store.commit('registration/setCaregiverToken', value)
            }
        },

        caregiverCheckToken: {
            get: function () {
                return this.$store.state.registration.caregiverCheckToken
            },
            set: function (value) {
                this.$store.commit('registration/setCaregiverCheckToken', value)
            }
        },

        noCheckToken: {
            get: function () {
                return this.$store.state.registration.noCheckToken
            },
            set: function (value) {
                this.$store.commit('registration/setNoCheckToken', value)
            }
        },
    },

    methods: {
        /////////////////////////////////////////////////
        //Mutations
        /////////////////////////////////////////////////

        setRegistrationProp(prop, value, path = null) {
            this.$store.commit('registration/setRegistrationProp', {prop, value, path})
        },

        setEventData(eventData) {
            this.$store.commit('registration/setEventData', eventData)
        },

        setRegistrationData(registrationData) {
            this.$store.commit('registration/setRegistrationData', registrationData)
        },

        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchEventData(eventId, loadRemainingFreePlacesOnly = false) {
            return this.$store.dispatch('registration/fetchEventData', {eventId, loadRemainingFreePlacesOnly})
        },

        sendRegistration() {
            return this.$store.dispatch('registration/sendRegistration')
        }

    }
}
